import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Privacy from "./privacy";
import RefundPolicy from "./refundpolicy";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function Footer() {
  return (
    <>
      <div>
        <div className="container-fluid footer py-3 wow fadeIn text-center text-md-end" data-wow-delay="0.2s">
          <div className="container py-3">
            <div className="row g-5 justify-content-center justify-content-md-end me-md-1">
              <div className="col-md-6 col-lg-6 col-xl-3">
                <div className="footer-item d-flex flex-column align-items-center align-items-md-end">
                <a href="/contact" target=" " rel="noopener noreferrer">
  <h4 className="text-secondary mb-4">Contact Info</h4>
</a>                  
<a href="https://www.google.com/maps/search/?api=1&query=Century+Building,+Level+5/125+Swanston+Street,+Melbourne+VIC+3000" 
  target="_blank"     
  rel="noopener noreferrer"
>
  <i className="fa fa-map-marker-alt me-2"></i> Century Building, Level 5/125 Swanston Street, Melbourne VIC 3000
</a>

 <a href="mailto:enquiries@bajwaimmigration.com">
                    <i className="fas fa-envelope me-2"></i> enquiries@bajwaimmigration.com
                  </a>
                  <a href="tel:+0406401000">
                    <i className="fas fa-phone me-2"></i> +0406 401 000 
                  </a>
                  <div className="d-flex justify-content-center justify-content-md-end align-items-center">
                    <i className="fas fa-share fa-2x text-secondary me-2"></i>
                    <a className="btn mx-1" href="https://www.facebook.com/bajwaimmigration">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a className="btn mx-1" href="https://www.tiktok.com/@bajwaimmigration">
                      <i className="fab fa-tiktok"></i>
                    </a>
                    <a className="btn mx-1" href="https://www.instagram.com/bajwaimmigration/">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a className="btn mx-1" href="https://www.youtube.com/channel/UCB2YzDKqwiv4IH4A6zoKKWw">
                      <i className="fab fa-youtube"></i>
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-6 col-xl-3">
                <div className="footer-item text-center text-md-end">
                  <h5 className="text-white mb-3">
                    <a href="https://www.mara.gov.au/tools-for-registered-agents/code-of-conduct">
                      Code of Conduct
                    </a>
                  </h5>
                  <h5 className="text-white mb-3">
                    <a href="/refundpolicy">Refund Policy</a>
                  </h5>
                  <h5 className="text-white mb-3">
                    <a href="/terms&services">Terms of Services</a>
                  </h5>
                  <h5 className="text-white mb-3">
                    <a href="/privacypolicy">Privacy Policy</a>
                  </h5>
                  
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid copyright py-2">
          <div className="container">
            <div className="row g-4 align-items-center justify-content-center">
              <div className="col-md-6 text-center mb-md-0">
                <span className="text-white">
                  <a href="#" className="border-bottom text-white">
                    <i className="fas fa-copyright text-light me-2"></i>
                    Copyright © 2025 Bajwa Immigration And Consultants
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>
      
    </>
  );
}

export default Footer;